var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9834 8.99167V12.325C14.9834 12.5417 14.9751 12.75 14.9501 12.95C14.7584 15.2 13.4334 16.3167 10.9917 16.3167H10.6584C10.4501 16.3167 10.2501 16.4167 10.1251 16.5833L9.12509 17.9167C8.68342 18.5083 7.96675 18.5083 7.52508 17.9167L6.52507 16.5833C6.41674 16.4417 6.17508 16.3167 5.99175 16.3167H5.65842C3.00009 16.3167 1.66675 15.6583 1.66675 12.325V8.99167C1.66675 6.55001 2.79176 5.22501 5.03342 5.03334C5.23342 5.00834 5.44176 5 5.65842 5H10.9917C13.6501 5 14.9834 6.33334 14.9834 8.99167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3168 5.65818V8.99151C18.3168 11.4415 17.1918 12.7582 14.9501 12.9498C14.9751 12.7498 14.9834 12.5415 14.9834 12.3248V8.99151C14.9834 6.33318 13.6501 4.99984 10.9918 4.99984H5.65845C5.44178 4.99984 5.23345 5.00818 5.03345 5.03318C5.22511 2.79151 6.55011 1.6665 8.99178 1.6665H14.3251C16.9834 1.6665 18.3168 2.99984 18.3168 5.65818Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.2462 11.0417H11.2537",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.32966 11.0417H8.33716",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.41292 11.0417H5.42042",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4b38420183b061b94149848dbb58ea9e.svg";
export { ForwardRef as ReactComponent };